<template>
    <div :id="id" style="width: 100%; height: 350px; background-color: #D0CFCF;"></div>
</template>
<script>
import yMapsMixin from '@mixins/YMaps.vue';
export default {
    mixins: [yMapsMixin],
    props: {
        id: {
            type: String,
            required: true
        },
        markLat: {
            type: Number,
            required: true
        },
        markLong: {
            type: Number,
            required: true
        },
        mapZoom: {
            type: Number,
            required: true
        },
        disable: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function () { return { mapId: 'Ymap'   }},
    created: function () {
        this.mapId = this.id
        ymaps.ready(() => {
            this.initMap(this.disable);
            this.updateMap(this.markLat, this.markLong, this.mapZoom);
        });
    },
    methods: {
        coordsToModel: function () {
            this.$nextTick(() => {
                let coords = this.mapSettings.clinicsPlacemark.geometry.getCoordinates();
                this.$emit('updateCoords', coords[0], coords[1], this.mapSettings.clinicsMap.getZoom())
            });
        },
        update(markLat, markLong, mapZoom){
            this.updateMap(markLat, markLong, mapZoom)
        }
    }
}
</script>
